import React from 'react';
import { useLocalization } from '../contexts/LocalizationContext';
import Icon from './Icon';

const links = [
  {
    label: 'footer.give.feedback',
    href: window._env.urls?.feedback
  },
  {
    label: 'footer.privacy.and.cookies',
    href: window._env.urls?.privacyAndCookies
  },
  {
    label: 'footer.accessibility.statement',
    href: window._env.urls?.accessibility
  }
];

export default function Footer() {
  const { localize } = useLocalization();

  return (
    <footer>
      <div className='d-flex flex-column gap-1 flex-md-row justify-content-evenly align-items-center gap-md-5'>
        {links.map((link) => (
          <React.Fragment key={link.label}>
            {link.href ? (
              <a
                style={{ flex: '1' }}
                className='text-nowrap text-decoration-none text-dark py-1 px-2'
                target='_blank'
                href={link.href}>
                {localize(link.label)}
                <Icon name='ArrowSquareOut' className='ms-2' size={18} />
              </a>
            ) : (
              ''
            )}
          </React.Fragment>
        ))}
      </div>
    </footer>
  );
}
